export enum EnSortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}
